import axios from 'axios'
import HTTP from './http'

export default {
    getResults: params => axios.get(HTTP.SURVEY_RESULTS, { params }),
    getReferentScores: params => axios.get(HTTP.SURVEY_REFERENT_SCORES, { params })
}
